import { __decorate, __metadata } from "tslib";
import { CanvasConfig, ContextService } from '@antv/g';
import { inject, singleton } from 'mana-syringe';
import { isString } from '@antv/util';
import { setDOMSize } from './utils/dom';
import { isBrowser } from './utils/browser';

var WebGLContextService =
/** @class */
function () {
  function WebGLContextService() {}

  WebGLContextService.prototype.init = function () {
    var _a = this.canvasConfig,
        container = _a.container,
        canvas = _a.canvas,
        devicePixelRatio = _a.devicePixelRatio;

    if (canvas) {
      this.$canvas = canvas;

      if (container && canvas.parentElement !== container) {
        container.appendChild(canvas);
      }

      this.$container = canvas.parentElement;
      this.canvasConfig.container = this.$container;
    } else if (container) {
      // create container
      this.$container = isString(container) ? document.getElementById(container) : container;

      if (this.$container) {
        // create canvas
        var $canvas = document.createElement('canvas');
        this.$container.appendChild($canvas);

        if (!this.$container.style.position) {
          this.$container.style.position = 'relative';
        }

        this.$canvas = $canvas;
      }
    } // use user-defined dpr first


    var dpr = devicePixelRatio || isBrowser && window.devicePixelRatio || 1;
    dpr = dpr >= 1 ? Math.ceil(dpr) : 1;
    this.dpr = dpr;
  };

  WebGLContextService.prototype.getDomElement = function () {
    return this.$canvas;
  };

  WebGLContextService.prototype.getContext = function () {
    return this.context;
  };

  WebGLContextService.prototype.getBoundingClientRect = function () {
    var _a;

    return (_a = this.$container) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
  };

  WebGLContextService.prototype.destroy = function () {
    // @ts-ignore
    if (this.$container && this.$canvas && this.$canvas.parentNode) {
      // @ts-ignore
      this.$container.removeChild(this.$canvas);
    }
  };

  WebGLContextService.prototype.resize = function (width, height) {
    if (this.$canvas) {
      var dpr = this.getDPR(); // set canvas width & height

      this.$canvas.width = dpr * width;
      this.$canvas.height = dpr * height; // set CSS style width & height

      setDOMSize(this.$canvas, width, height);
    }
  };

  WebGLContextService.prototype.getDPR = function () {
    return this.dpr;
  };

  WebGLContextService.prototype.applyCursorStyle = function (cursor) {
    if (this.$container && this.$container.style) {
      this.$container.style.cursor = cursor;
    }
  };

  __decorate([inject(CanvasConfig), __metadata("design:type", Object)], WebGLContextService.prototype, "canvasConfig", void 0);

  WebGLContextService = __decorate([singleton({
    token: ContextService
  })], WebGLContextService);
  return WebGLContextService;
}();

export { WebGLContextService };